import React from 'react';
import {Link as RouterLink} from 'react-router';
import CookieConsent from 'react-cookie-consent';
import posthog from 'posthog-js';
import {POSTHOG_ENABLED} from '../PostHogAnalytics';

const privacyLinkClassName =
  'font-medium text-inherit underline underline-offset-2 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--compass-focus-ring)';

const CookieConsentBanner = ({privacyHref}) => {
  const privacyLinkProps = {
    className: privacyLinkClassName,
    target: '_blank',
    rel: 'noreferrer',
  };
  return (
    <CookieConsent
      location="bottom"
      buttonText="Accept"
      cookieName="compassCookieConsent"
      // The Launch site's 18px floor (COM-442), which the Launch application shows this
      // banner on: the buttons inherit it from the container.
      containerClasses="CookieConsent text-lg"
      style={{background: '#12545c'}}
      // Both buttons keep Compass's 44px pointer target (COM-385).
      buttonStyle={{
        borderRadius: '16px',
        padding: '6px 16px',
        minHeight: '44px',
        minWidth: '44px',
        cursor: 'pointer',
        backgroundColor: '#ed6f43',
        color: 'var(--compass-color-almost-black)',
      }}
      declineButtonStyle={{
        borderRadius: '16px',
        padding: '6px 16px',
        minHeight: '44px',
        minWidth: '44px',
        cursor: 'pointer',
        backgroundColor: '#12545c',
        borderWidth: '1px',
        borderStyle: 'solid',
      }}
      declineButtonText="Decline"
      enableDeclineButton
      onAccept={() => {
        if (POSTHOG_ENABLED) {
          posthog.opt_in_capturing();
        }
      }}
      onDecline={() => {
        if (POSTHOG_ENABLED) {
          posthog.opt_out_capturing();
        }
      }}>
      {/* The MUI body2 line height and tracking this text was set in. */}
      <p className="m-0 text-lg leading-[1.43] tracking-[0.01071em]" style={{color: 'white'}}>
        Compass uses cookies to collect analytics data to improve your experience. By clicking
        &apos;Accept&apos;, you consent to the use of cookies. You can change your cookie settings
        at any time. Read our{' '}
        {privacyHref ? (
          <a href={privacyHref} {...privacyLinkProps}>
            privacy notice
          </a>
        ) : (
          <RouterLink to="/privacy" {...privacyLinkProps}>
            privacy notice
          </RouterLink>
        )}{' '}
        to find out more or click &apos;Decline&apos; to opt-out of cookies.
      </p>
    </CookieConsent>
  );
};

export default CookieConsentBanner;
